export default [
  {
    path: '/zones-services',
    name: 'zones-services',
    component: () => import('@/views/ZonesServices.vue'),
    meta: {
      resource: 'zones/services',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Zones/Services',
      breadcrumb: [
        {
          text: 'Zones/Services ',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
]
